import { render, staticRenderFns } from "./CbxExpenseType.vue?vue&type=template&id=69b72a98&"
import script from "./CbxExpenseType.vue?vue&type=script&lang=ts&"
export * from "./CbxExpenseType.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports